import styled from "styled-components";

const S = {
    Wrapper: styled.div`
        display: flex;
        flex-direction: column;
        padding: 60px 100px;
        margin: 0;
        align-items: center;
        background: linear-gradient(135deg, #ffffff 0%, #f0fbfc 100%);
        border-top: 1px solid rgba(0, 169, 196, 0.1);
        border-bottom: 1px solid rgba(0, 169, 196, 0.1);
        box-sizing: border-box;
        width: 100%;
        
        @media (max-width: 1024px) {
            padding: 40px 24px;
        }

        @media (max-width: 600px) {
            padding: 32px 14px;
        }
    `,
    Sol: styled.div`
        width: 100%;
        margin-bottom: 40px;
        text-align: center;
        
        @media (max-width: 768px) {
            margin-bottom: 24px;
        }

        a {
            text-decoration: none;
            p {
                margin: 0;
                b {
                    font-size: 3.5em;
                    font-weight: 800;
                    color: #1a2b34;
                    letter-spacing: -1px;

                    @media (max-width: 1024px) {
                        font-size: 2.5em;
                    }

                    @media (max-width: 600px) {
                        font-size: 1.85em;
                        letter-spacing: -0.5px;
                    }
                }
            }
        }
    `,
    Sag: styled.div`
        width: 100%;
        max-width: 1400px;
    `,
    Dip: styled.div`
        margin-top: 40px;
        width: 100%;
        display: flex;
        justify-content: center;

        @media (max-width: 768px) {
            margin-top: 24px;
        }

        a {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            background: #00A9C4;
            color: #fff;
            padding: 14px 36px;
            border-radius: 12px;
            font-size: 1.1em;
            font-weight: 600;
            box-shadow: 0px 8px 20px rgba(0, 169, 196, 0.25);
            transition: all 0.3s ease;
            border: 2px solid #00A9C4;
            text-align: center;

            @media (max-width: 600px) {
                padding: 12px 28px;
                font-size: 0.95em;
                width: 100%;
                max-width: 260px;
            }

            svg {
                transition: transform 0.3s ease;
                fill: #fff;
            }

            &:hover {
                background: #008ba1;
                border-color: #008ba1;
                transform: translateY(-3px);
                box-shadow: 0px 12px 30px rgba(0, 169, 196, 0.4);
                
                svg {
                    transform: translateX(6px);
                }
            }
        }
    `
};

export default S;